import SortOption from '~/constants/common/SortOption';

export const SortOptionsWithLabels = [
  { label: 'Recommended', key: SortOption.MostPopular },
  { label: 'Lowest Monthly', key: SortOption.MonthlyPayment },
  { label: 'Lowest Cash Down', key: SortOption.CashDue },
  { label: 'Lowest Price', key: SortOption.LowestPrice },
  { label: 'Highest Price', key: SortOption.HighestPrice },
  { label: 'Soonest Availability', key: SortOption.AcquisitionTime },
  { label: 'Lowest Shipping Cost', key: SortOption.FreeShipping },
  { label: 'Lowest Mileage', key: SortOption.LowestMileage },
  { label: 'Newest Inventory', key: SortOption.NewestInventory },
  { label: 'Newest Year', key: SortOption.NewestYear }
];

export const validSoftPullSortOptions = [
  SortOption.CashDue,
  SortOption.MonthlyPayment
];

export default SortOption;
